/* eslint-disable no-param-reassign */
import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RootState } from 'app/store/store';
import { Item } from 'app/services/itemsSearchService';
import { DialogFormData } from 'common/receipt.types';

export interface ItemState {
  selectedItem: Item | DialogFormData | null;
  itemIndex: number | null;
}

const initialState: ItemState = {
  selectedItem: null,
  itemIndex: null,
};

const itemSlice = createSlice({
  name: 'item',
  initialState,
  reducers: {
    clearSelectedItem: (state) => {
      state.selectedItem = null;
      state.itemIndex = null;
    },
    setSelectedItem: (
      state,
      action: PayloadAction<{ item: Item | DialogFormData; index?: number }>,
    ) => {
      state.selectedItem = action.payload.item;
      state.itemIndex = action.payload.index ?? null;
    },
  },
});

export const { clearSelectedItem, setSelectedItem } = itemSlice.actions;

export const getSelectedItem = (state: RootState) => state.item.selectedItem;
export const getSelectedItemIndex = (state: RootState) => state.item.itemIndex;

export default itemSlice.reducer;
